import styles from "../../styles/applicationDetail.module.css";
import { deniedCheckboxDataHasDisplayableEntries } from "./creditReportTabLogic";
import type { CreditReportDeniedReasonSectionProps } from "../../types";

export function CreditReportDeniedReasonSection({
  tab,
}: CreditReportDeniedReasonSectionProps) {
  const { deniedCheckboxData } = tab;

  if (!deniedCheckboxDataHasDisplayableEntries(deniedCheckboxData)) return null;

  return (
    <div className={`${styles.section} mt-8`} data-testid="application-credit-report-tab-section-denied-reason">
      <h2 className={styles.sectionTitle} data-testid="application-credit-report-tab-denied-reason-title">Denied Reason</h2>
      <div className={styles.deniedReasonSection}>
        {typeof deniedCheckboxData === "object" ? (
          Object.entries(deniedCheckboxData as Record<string, { label?: string; child?: Record<string, unknown> }>).map(([key, value], index) => (
            <div key={index} className="ml-5 mt-1">
              <div className="row">
                <label className="mb-3 font-bold" dangerouslySetInnerHTML={{ __html: value?.label || key }}></label>
              </div>
              {value?.child && Object.entries(value.child as Record<string, { label?: string; description?: string }>).map(([childKey, childValue], childIndex) => (
                <div key={childIndex} className="ml-3">
                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <label className="ml-2 mt-0" dangerouslySetInnerHTML={{ __html: childValue?.label || childKey }}></label>
                    </div>
                  </div>
                  {childValue?.description && (
                    <ul className="row ml-2">
                      <li className="col-md-12 mt-0">
                        <label className="mt-0" dangerouslySetInnerHTML={{ __html: childValue.description }}></label>
                      </li>
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))
        ) : (
          <p>{String(deniedCheckboxData)}</p>
        )}
      </div>
    </div>
  );
}
